const PATH = {
  HOME: '/',
  LOGIN: '/login',
  ANALYTICS: '/analytics',
  COMPANY: '/company',
  ALL_COMPANIES: '/all_companies',
  CREATE_JOB: '/create_job',
  JOBS: '/jobs',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  USER: '/user',
  SIGN_UP: '/signup',
  RESET_PASSWORD: '/resetPassword',
  ACCESS_DENIED: '/access_denied',
  NO_ACCESS: '/no_access',
  SERVER_REDIRECT: '/serverRedirect',
  SUB_ROUTE_EDIT: 'edit',
  COMPANY_BLOCKED: '/access_blocked',
  ADMIN_PAGE: '/admin',
  ADMIN_PAGE_USER: '/admin/user',
  PARTNERS: '/admin/partners',
  ANALYTICS_PERMIT: 'permits',
  ANALYTICS_HERS: 'hers',
  ANALYTICS_FINANCE: 'finance',
  PERMIT_JOB_ANALYTICS: '/permit_job_analytics',
  PERMIT_JOB_WEEKLY_ANALYTICS: '/permit_job_weekly_analytics',
  INSPECTION_ANALYTICS: '/inspection_analytics',
  INSPECTION_WEEKLY_ANALYTICS: '/inspection_weekly_analytics',
  REGISTER_COMPANY: '/register_company',
  PRODUCTS: '/products',
  TAGS: '/tags',
  TAG_JOBS: '/tagJobs',
  COMPANY_EXISTS: '/registration_reject',
  COMPANY_PENDING: '/company_under_review',
  MODULE: '/module',
  MODULE_RECORD: '/module/:id',
  STATES: '/states',
  STATE: '/states/:id',
  REBATES: '/rebates',
  REBATE: '/rebates/:id',
  ADD_STATE: '/add_state',
  CITIES: '/cities',
  CITY: '/cities/:id',
  ADD_CITY: '/add_city',
  CHEERS_CONNECTION_REQUIRED: '/connect-to-cheers',
  RATERS: '/raters',
  RATER: '/raters/user',
  INSPECTION_SCHEDULE: '/inspection-schedule',
  QUICKBOOKS_CALLBACK: '/quickbooksCallback',
  CALL_LOGS: '/call-logs',
  ZOHO_LOGS: '/zoho-logs',
  AI_CALLS: '/ai-calls',
  MY_AI_CALLS: '/my-ai-calls',
  AI_DASHBOARD: '/ai-dashboard',
  JOT_FORM: '/final-inspection/jot-form',
};

export default PATH;
